import React from 'react'
import Layout from '../components/layout'
import { TbChevronRight } from 'react-icons/tb';
import { Link } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"

const SuccessStories = () => {

    return (
        <Layout pageTitle='Success Stories - Dochase Adx'>
            <div className='lg:max-w-[1440px] mx-auto pt-20 lg:pt-28'>
                <section className='relative inline-block w-full'>
                    <StaticImage
                        src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332258/dochaseadx/l2jqb2vx76ujfbhuv1a9.png"
                        alt='success story'
                        placeholder="blurred"
                        quality="100"
                        className='block max-w-full mx-auto'
                    />
                    <div className='absolute top-[55%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[80%]'>
                        <p className='text-white font-bold text-3xl lg:text-8xl text-center'>Stories of Success and Happiness</p>
                        <p className='text-white font medium text-sm lg:text-3xl text-center mt-5 lg:mt-11 lg:mx-[20%]'>We always deliver on our goals and that is why we are trusted by several brands across different sectors to deliver on their business needs.</p>
                        <div className='w-full flex justify-center'>
                            <Link to='/#form'>
                                <button className='bg-brand-red text-white py-1 lg:py-3 px-5 lg:px-11 rounded-md font-bold mt-7 lg:mt-14 text-xs lg:text-sm'>Contact Us</button>
                            </Link>
                        </div>
                    </div>
                </section>

                <section className='my-36 grid lg:grid-cols-3 gap-16 lg:mx-[10%]'>
                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331982/dochaseadx/hjsnpr4ksiztcazcqj5v.png'
                            alt='peak'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331966/dochaseadx/htszkgkajq7ih7gla0pa.svg' alt='peak' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>Using different interactive Rich media creatives, we increased Peak’s brand awareness by 95% leveraging all operating systems.</p>
                            <Link to={'/detailed-stories#peak'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331863/dochaseadx/uhasesnt0ip1vllfnwdp.png'
                            alt='budweiser'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331863/dochaseadx/csbysyley6qexnag8gjt.svg' alt='Budweiser' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>See how we successfully created an awareness campaign, reaching an impressive audience of 3.2 million users for the Budweiser Smooth King remix.</p>
                            <Link to={'/detailed-stories#budweiser'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331759/dochaseadx/okmftcw6iy7y9nvq0kkl.png'
                            alt='flutterwave'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331756/dochaseadx/o5zzrx0lsm1jwkydmmlh.svg' alt='Flutterwave' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We helped Flutterwave acquire 50,000 merchants for their platform across a few African countries.</p>
                            <Link to={'/detailed-stories#flutterwave'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331758/dochaseadx/qr12ygwetnhvhf35lfcz.png'
                            alt='fcmb'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331755/dochaseadx/ikjkakmt1ke4hyhzhgsw.svg' alt='fcmb' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We created a strategic awareness campaign that seamlessly merged FCMB's aspirations with our expertise in delivering impactful advertising solutions.</p>
                            <Link to={'/detailed-stories#fcmb'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332187/dochaseadx/sg5i8vxqgwa6vrkzyz0w.png'
                            alt='tecno'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332180/dochaseadx/mxu3riycrmuingmkacck.svg' alt='tecno' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We helped Tecno drive sales by engaging with a number of platforms, including over 200 sites and apps, alongside a robust SMS campaign with 20K+ tags. </p>
                            <Link to={'/detailed-stories#budweiser'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331846/dochaseadx/jqjlinlmiagphwvj6rcx.png'
                            alt='bitmama'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331844/dochaseadx/dzb1yml0pbepc5gs5yhu.svg' alt='bitmama' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We used Data-powered media buying, and programmatic advertising platforms with global reach and superior targeting.</p>
                            <Link to={'/detailed-stories#bitmama'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331833/dochaseadx/csrob0k9fgn7jav10ql5.png'
                            alt='bet9ja'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331809/dochaseadx/mlx5jq7sl2oh90rpjndg.svg' alt='bet9ja' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We used Data-powered media buying, and programmatic advertising platforms with global reach and superior targeting.</p>
                            <Link to={'/detailed-stories#bet9ja'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331849/dochaseadx/n0ichiuppjyv3amqi6xg.png'
                            alt='apex'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331761/dochaseadx/qz4an4plcaktoes0rf7t.svg' alt='apex' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>Leveraging our programmatic data, we narrowed down the brand’s audience and targeted them on behavioural and location parameters.</p>
                            <Link to={'/detailed-stories#apex'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                    <div className='w-72 mx-auto' >
                        <StaticImage
                            src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696332007/dochaseadx/wsouqxiu156xm50aqebf.png'
                            alt='nosh'
                            placeholder="blurred"
                            quality="100"
                            className='w-72 h-52 object-cover rounded-t-xl'
                        />
                        <div className='text-center rounded-b-2xl shadow-lg relative pb-12 h-44'>
                            <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331949/dochaseadx/ar6oqqh98mi31covevb1.svg' alt='nosh' className='mx-auto mt-5 h-12' loading='lazy'/>
                            <p className='mt-2 px-8 text-[#4F4F4F] text-xs'>We helped Nosh amplify their brand recognition and expand its user base through strategic advertising.</p>
                            <Link to={'/detailed-stories#nosh'}>
                                <button className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-28'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
                            </Link>
                        </div>
                    </div>

                </section>
            </div>
        </Layout>
    )
}

export default SuccessStories